/**
 * @generated SignedSource<<4fad02bd97d63ab2d175e8b7095a61e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MediaType = "cast" | "ins_highlight" | "ins_image" | "ins_live" | "ins_reel_story" | "ins_story" | "ins_video" | "other" | "tiktok" | "tiktok_go" | "twitter_image" | "twitter_video" | "youtube" | "youtube_short";
import { FragmentRefs } from "relay-runtime";
export type PostDraftTwitter$data = {
  readonly attachments: ReadonlyArray<{
    readonly contentType: string | null;
    readonly duration: number | null;
    readonly file: string;
    readonly id: string;
  }>;
  readonly campaign: {
    readonly avoidedSentence: string | null;
    readonly mediaType: MediaType;
    readonly purpose: string | null;
    readonly socialNetwork: {
      readonly hashTag: string | null;
      readonly mentionTagContent: string | null;
      readonly productUrl: string | null;
    };
  };
  readonly content: string | null;
  readonly id: string;
  readonly " $fragmentType": "PostDraftTwitter";
};
export type PostDraftTwitter$key = {
  readonly " $data"?: PostDraftTwitter$data;
  readonly " $fragmentSpreads": FragmentRefs<"PostDraftTwitter">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PostDraftTwitter",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "file",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Campaign",
      "kind": "LinkedField",
      "name": "campaign",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mediaType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "purpose",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avoidedSentence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SocialNetwork",
          "kind": "LinkedField",
          "name": "socialNetwork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hashTag",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mentionTagContent",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "e009101e5cdb9956d45b2cfc3a1eefa6";

export default node;
